import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styled, { css } from 'styled-components';
import createTheme from 'styled-variants';
import { ButtonTheme } from '@awaze/design-system.components.button';
import { breakpoints, pxToRems, } from '@awaze/design-system.utils.react';
const colourSchemes = ({ theme }) => {
    return {
        none: {
            color: 'unset',
            '&:hover, &:focus': {
                color: 'unset',
            },
        },
        'brand-link': {
            color: theme.ColorThemeLink,
            '&:hover, &:focus': {
                color: theme.ColorThemeLinkActive,
            },
        },
        'brand-primary': {
            color: theme.ColorThemeCtaPrimary,
            '&:hover, &:focus': {
                color: theme.ColorThemeCtaPrimaryActive,
            },
        },
        'brand-secondary': {
            color: theme.ColorThemeCtaSecondary,
            '&:hover, &:focus': {
                color: theme.ColorThemeCtaSecondaryActive,
            },
        },
        reverse: {
            color: theme.ColorButtonGhostReverseText,
            '&:hover, &:focus': {
                color: theme.ColorButtonGhostReverseTextHover,
            },
        },
    };
};
const variants = ({ theme, underline }) => ({
    text: {
        'text-decoration': underline ? 'underline' : 'none',
    },
    'button-primary': ButtonTheme({
        theme,
        variant: 'solid',
        colourScheme: 'brand-primary',
    }),
    'button-secondary': ButtonTheme({
        theme,
        variant: 'solid',
        colourScheme: 'brand-secondary',
    }),
});
const LinkTheme = createTheme('Link', {})
    .addVariant('colourScheme', colourSchemes)
    .addVariant('variant', variants);
const LinkStyled = styled.a(LinkTheme);
export const LinkStyle = styled(LinkStyled) `
  ${({ sizes, theme }) => {
    if (!sizes) {
        return null;
    }
    const size = sizes[0] || sizes;
    return css `
      font-size: ${pxToRems(theme[`FontTextText${size}FontSize`])};

      ${Array.isArray(sizes) &&
        css `
        @media screen and (min-width: ${breakpoints[0]}px) {
          font-size: ${pxToRems(theme[`FontTextText${size[1]}FontSize`])};
        }

        @media screen and (min-width: ${breakpoints[1]}px) {
          font-size: ${pxToRems(theme[`FontTextText${size[2]}FontSize`])};
        }
      `}
    `;
}}
`;
/**
 * TODO: Description to be provided by component owner.
 */
export const Link = memo(({ children, href, sizes, title, underline = true, colourScheme = 'brand-link', openInNewTab = false, rel, variant = 'text', testId = 'link', dataGa, }) => {
    const target = openInNewTab ? { target: '_blank' } : null;
    const dataGaProps = dataGa ? { 'data-ga': dataGa } : {};
    return (_jsx(LinkStyle, { href: href, sizes: sizes, title: title, underline: underline, colourScheme: colourScheme, rel: rel, variant: variant, "data-testid": testId, ...dataGaProps, ...target, children: children }));
});
//# sourceMappingURL=link.js.map